export default "__VITE_ASSET__d7909819__"